import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_SHARED_DETAIL_REPORT } from '@custom/constant';

import axios from 'axios';

// Create the thunk for fetching rollback report details (without auth token)
export const fetchSharedReport = createAsyncThunk(
  'rollbackReport/fetchRollbackReport',
  async (_id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${GET_SHARED_DETAIL_REPORT}/${_id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);